import { Radius } from './Border';
import * as BaseColor from './Color';
export var SelectSize;
(function (SelectSize) {
    SelectSize[SelectSize["XSmall"] = 155] = "XSmall";
    SelectSize[SelectSize["Small"] = 180] = "Small";
    SelectSize[SelectSize["Medium"] = 220] = "Medium";
    SelectSize[SelectSize["Large"] = 280] = "Large";
})(SelectSize || (SelectSize = {}));
export var DropdownSize;
(function (DropdownSize) {
    DropdownSize[DropdownSize["Small"] = 180] = "Small";
    DropdownSize[DropdownSize["Medium"] = 220] = "Medium";
    DropdownSize[DropdownSize["Large"] = 280] = "Large";
})(DropdownSize || (DropdownSize = {}));
export var CheckboxSize;
(function (CheckboxSize) {
    CheckboxSize[CheckboxSize["XSmall"] = 12] = "XSmall";
    CheckboxSize[CheckboxSize["Small"] = 16] = "Small";
    CheckboxSize[CheckboxSize["Medium"] = 20] = "Medium";
    CheckboxSize[CheckboxSize["Large"] = 28] = "Large";
    CheckboxSize[CheckboxSize["XLarge"] = 44] = "XLarge";
})(CheckboxSize || (CheckboxSize = {}));
export var RadioSize;
(function (RadioSize) {
    RadioSize[RadioSize["XSmall"] = 12] = "XSmall";
    RadioSize[RadioSize["Small"] = 16] = "Small";
    RadioSize[RadioSize["Medium"] = 20] = "Medium";
    RadioSize[RadioSize["Large"] = 28] = "Large";
    RadioSize[RadioSize["XLarge"] = 44] = "XLarge";
})(RadioSize || (RadioSize = {}));
export const Input = {
    Radius: Radius.Medium,
    Placeholder: {
        Color: BaseColor.Neutrals.Text,
    },
    Size: 'SmallHeavy',
    Number: {
        Radius: Radius.Medium,
    },
};
export const InputSize = {
    Small: { width: 64, height: 24 },
    Medium: { width: 288, height: 40 },
};
export const FontSize = {
    Small: 12,
};
export const Switch = {
    Color: BaseColor.System.Success,
    Size: {
        Medium: {
            width: 36,
            height: 20,
            handleSize: 14,
            trackPadding: 3,
            transitionDistance: 16,
        },
        Small: {
            width: 28,
            height: 16,
            handleSize: 12,
            trackPadding: 2,
            transitionDistance: 12,
        },
    },
};
export const InputNumberControllers = {
    Small: { width: 24 },
};
export const InputAddons = {
    width: 36,
};
export const Slider = {
    thumb: {
        size: 16,
        border: {
            width: 1,
            color: BaseColor.Neutrals.Border,
        },
        shadow: `0 0 0 5px ${BaseColor.Brand.Light}`,
    },
    track: {
        height: 2,
    },
};
export const TextArea = {
    Radius: Radius.Large,
};
export const Checkbox = {
    Color: {
        Background: BaseColor.Neutrals.Paper,
    },
};
//# sourceMappingURL=Form.js.map